import { useResolvedPath } from "react-router-dom";
import { useEffect } from "react";
import RouteNames from "../../config/RouteNames";

export default function useDocumentTitle() {
  const { pathname: route } = useResolvedPath();

  useEffect(() => {
    const routeName = RouteNames[route];
    if (routeName) {
      document.title = routeName + " - B7 ID";
    } else {
      document.title = "B7 ID";
    }
  }, [route]);
}
